export default __webpack_public_path__ + "static/media/dotdot.53eb83da.svg";